import { feedback } from '../feedback'

/**
 * Displays a standardized error feedback for a "Too Many Requests" (429) error.
 * @param {function} formatMessage - The `formatMessage` function from react-intl.
 */
export const showTooManyRequestsError = (formatMessage) => {
  feedback('error', formatMessage({ id: `calls.too.many.requests.error.description` }))
}
